<template>
  <v-row>
    <v-col v-if="showPlatform" cols="12">
      <v-autocomplete
        :value="value.platformOrDataHost"
        :label="$t('label.notification.platformOrDataHost')"
        :items="autocompletion.platformOrDataHost"
        multiple
        clearable
        hide-details
        @input="updateFilter('platformOrDataHost', $event)"
      />
    </v-col>
    <v-col v-if="showRelease" cols="12">
      <v-autocomplete
        :value="value.releases"
        :label="$t('label.notification.release')"
        :items="autocompletion.counterReleases"
        multiple
        clearable
        hide-details
        chips
        @input="updateFilter('releases', $event)"
      >
        <template #selection="{ item }">
          <v-chip :color="item === '5' ? '#cde9fa' : '#cbfcdc'" label>
            {{ item }}
          </v-chip>
        </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        :value="value.types"
        :label="$t('label.notification.type')"
        :items="autocompletion.types"
        multiple
        clearable
        hide-details
        @input="updateFilter('types', $event)"
      >
        <template #selection="{ item }">
          {{ $t(`translation.notification.type.${item}`) }}
        </template>
        <template #item="{ item, attrs, on }">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-action>
              <v-simple-checkbox
                :disabled="attrs.disabled"
                :value="attrs.inputValue"
                :ripple="attrs.ripple"
                v-on="on"
              />
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>
                {{ $t(`translation.notification.type.${item}`) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        :value="value.sources"
        :label="$t('label.notification.source')"
        :items="autocompletion.sources"
        multiple
        clearable
        hide-details
        @input="updateFilter('sources', $event)"
      >
        <template #selection="{ item }">
          {{ $t(`translation.notification.source.${item}`) }}
        </template>
        <template #item="{ item, attrs, on }">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-action>
              <v-simple-checkbox
                :disabled="attrs.disabled"
                :value="attrs.inputValue"
                :ripple="attrs.ripple"
                v-on="on"
              />
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>
                {{ $t(`translation.notification.source.${item}`) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        :value="value.reports"
        :label="$t('label.notification.reports')"
        :items="autocompletion.counterReports"
        multiple
        clearable
        hide-details
        chips
        @input="updateFilter('reports', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { notificationTargetName } from "../lib/listFilters";

export default {
  name: "NotificationFilters",

  props: {
    value: { required: true, type: Object },
    notifications: { type: Array, default: () => [] },
    showPlatform: { type: Boolean, default: false },
    showRelease: { type: Boolean, default: false },
  },

  computed: {
    autocompletion() {
      const platformOrDataHost = new Set();
      const counterReleases = new Set();
      const types = new Set();
      const sources = new Set();
      const counterReports = new Set();

      for (const item of this.notifications) {
        if (item.type) {
          types.add(item.type);
        }
        if (item.source) {
          sources.add(item.source);
        }

        if (this.showPlatform) {
          const name = notificationTargetName(item);
          if (name) {
            platformOrDataHost.add(name);
          }
        }
        if (this.showRelease && item.sushi_service?.counter_release) {
          counterReleases.add(item.sushi_service.counter_release);
        }

        (item.reports || []).forEach((report) => {
          if (report.report_id) {
            counterReports.add(report.report_id);
          }
        });
      }

      return {
        platformOrDataHost: Array.from(platformOrDataHost).sort(),
        counterReleases: Array.from(counterReleases).sort(),
        types: Array.from(types).sort(),
        sources: Array.from(sources).sort(),
        counterReports: Array.from(counterReports).sort(),
      };
    },
  },

  methods: {
    updateFilter(key, value) {
      this.$emit("input", { ...this.value, [key]: value || [] });
    },
  },
};
</script>
